/** @jsxImportSource @emotion/react */
import { Icon, Tooltip } from "@blueprintjs/core"
import { format, parseISO } from "date-fns"

import { QueryStatus } from "@tanstack/react-query"
import { FlexContainer } from "../../../../styled/flexbox.styled"
import { SCIENT_COLORS } from "../../../../styled/scientColors"
import { LargeText, MediumText } from "../../../../styled/text.styled"
import WithLoading from "../../../components/WithLoading/WithLoading"
import { getWaveStatusIcon, waveStatusColor } from "../utils/waveStatusColor"
import { Wave } from "./types/wave"
import { HeaderContainer, SummaryContainer, TickerListContainer } from "./WaveDetail.styled"
import { DetailContainer } from "./WaveList.styled"
import WaveTickerGrid from "./WaveTickerGrid"

interface IWaveDetailProps {
  selectedWave: Wave | undefined
  status: QueryStatus
}

const WaveDetail = ({ selectedWave, status }: IWaveDetailProps) => {
  if (!selectedWave && status === "success") {
    return (
      <DetailContainer
        flexDirection="column"
        alignItems="center"
        justifyContent="center"
        gap="20px"
      >
        <Icon icon="document" size={100} />
        <LargeText>No Previous Waves selected</LargeText>
      </DetailContainer>
    )
  }

  return (
    <DetailContainer flexDirection="column" alignItems="center" gap="20px">
      <HeaderContainer justifyContent="space-around" alignItems="center">
        <FlexContainer gap="10px" alignItems="center">
          <Icon
            icon={selectedWave ? getWaveStatusIcon(selectedWave.status) : "help"}
            size={18}
            color={selectedWave ? waveStatusColor(selectedWave.status) : ""}
          />
          <LargeText color={selectedWave ? waveStatusColor(selectedWave.status) : ""}>
            {selectedWave?.status}
          </LargeText>
        </FlexContainer>
        <FlexContainer flexDirection="column" gap="5px">
          <MediumText>{`Created ${
            selectedWave?.created_at ? format(parseISO(selectedWave.created_at), "dd-MM-yyyy") : ""
          }`}</MediumText>
          {selectedWave?.updated_at && (
            <MediumText>{`Updated ${format(
              parseISO(selectedWave.updated_at),
              "dd-MM-yyyy",
            )}`}</MediumText>
          )}
        </FlexContainer>
        <Tooltip content={`Wave ID: ${selectedWave?.id}`}>
          <Icon icon="info-sign" size={18} />
        </Tooltip>
      </HeaderContainer>
      <TickerListContainer gap="8px" justifyContent="center">
        <WaveTickerGrid orders={selectedWave?.orders ?? []} isWaveDetail />
      </TickerListContainer>
      <SummaryContainer flexGrow={1}>
        <MediumText whiteSpace="pre-line" color={SCIENT_COLORS.black}>
          {selectedWave?.execution_summary}
        </MediumText>
      </SummaryContainer>
    </DetailContainer>
  )
}

export default WaveDetail
